import { render, staticRenderFns } from "./navItem.vue?vue&type=template&id=71681ac2&scoped=true&"
import script from "./navItem.vue?vue&type=script&lang=js&"
export * from "./navItem.vue?vue&type=script&lang=js&"
import style0 from "./navItem.vue?vue&type=style&index=0&id=71681ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71681ac2",
  null
  
)

component.options.__file = "navItem.vue"
export default component.exports